import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Configs from 'config';
import { get } from 'lodash';
import { DisplayName } from 'components/base/DisplayName';
import { ProfileWrapper } from 'components/mentoring/styles';
import { setInterestedIntern } from 'libs/api/user';
import { TMentoringClass, TSendbirdInfo } from 'modules/mentoring';
import { RouteMatch, TPagination } from 'modules/types';
import { TSimpleMentee, TMentee } from 'modules/user';
import { ERoute } from 'enums/route.enum';
import { Avatar, Button, Tag, Typography, message } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, LightGrayColor, MenteeColor } from 'GlobalStyles';
import CheckedSource from 'assets/icons/FavoriteChecked.webp';
import UncheckedSource from 'assets/icons/FavoriteUnchecked.webp';

const { Text, Title } = Typography;
export const CardWrapper = styled.div`
  color: #000;
  max-width: 250px;
  width: 100%;
  overflow: hidden;
  display: block;
  position: relative;
  text-align: center;
  border: 1px solid #f0f8f6;
  border-radius: 8px;
  padding: 15px;
  font-size: 14px;
  margin: auto;
  .card-detail {
    width: 100%;
    background: ${LightGrayColor};
    color: ${PrimaryColor};
    border-radius: 0 0 8 8px;
    margin-top: 8px;
    padding: 10px;
    text-align: left;
  }
  .name {
    margin-top: -8px;
  }
  .ant-divider {
    border-color: #f0f8f6;
  }
  .resume-btn {
    margin-top: 5px;
    width: 100%;
  }
  .resume-btn:hover {
    font-weight: bold;
  }
`;
type TMenteeCardProps = {
  mentee: TSimpleMentee | TMentee;
  pagination?: TPagination;
  reloadPage?: any;
  style?: object;
  useInterested?: boolean;
  useResume?: boolean;
  useClassCount?: boolean;
  meetingUrl?: string;
  sendbirdInfo?: TSendbirdInfo;
  data?: TMentoringClass;
};
const MenteeCard = ({
  mentee,
  pagination,
  reloadPage,
  style,
  useInterested = true,
  useResume = true,
  useClassCount = false,
  meetingUrl,
  sendbirdInfo,
  data,
}: TMenteeCardProps) => {
  const history = useHistory();
  const [isInterested, setIsInterested] = useState(get(mentee, 'is_interested', false));

  async function handleInterested() {
    try {
      await setInterestedIntern({
        mentee_id: get(mentee, 'id'),
        is_interested: !isInterested,
      });
      setIsInterested(!isInterested);
      reloadPage && (await reloadPage());
    } catch (e) {
      throw e;
    }
  }

  const match = useRouteMatch(`${ERoute.MentoringClassView}`);
  const { record_id } = (match?.params as RouteMatch) || {};

  useEffect(() => {
    setIsInterested(get(mentee, 'is_interested', false));
  }, [pagination, mentee]);

  return (
    <CardWrapper style={style}>
      {useInterested === true && (
        <div onClick={handleInterested} className='favorite-btn'>
          {isInterested === true ? (
            <img alt='checked' src={CheckedSource} />
          ) : (
            <img alt='unchecked' src={UncheckedSource} />
          )}
        </div>
      )}
      <ProfileWrapper style={{ maxWidth: '180px' }}>
        <Link to={`${ERoute.MentoringMenteeView.replace(':record_id', String(get(mentee, 'id')))}`}>
          <Avatar src={get(mentee, 'user.profile_image.absolute_url')} />
        </Link>
        <Tag className='user-type-tag' color={MenteeColor}>
          멘티
        </Tag>
        <div className='name' style={{ fontSize: 'calc(0.2vw + 12px)' }}>
          {get(mentee, 'user.fullname')}
        </div>
      </ProfileWrapper>
      <div
        style={{
          textAlign: 'center',
          width: '100%',
          fontSize: 'calc(0.4vw + 8px)',
        }}
      >
        <div>
          {DisplayName(get(mentee, 'user.educations', [])?.slice(-1)[0]?.university_name)}{' '}
          {get(mentee, 'user.educations', [])?.slice(-1)[0]?.major} 전공
        </div>
      </div>
      {meetingUrl && meetingUrl.length > 0 && (
        <>
          {meetingUrl === 'inactive' ? (
            <Button
              style={{ width: '100%', marginTop: '5px' }}
              className='btn-join'
              onClick={() => {
                message.error('수업 10분전부터 입장 가능합니다');
              }}
            >
              멘토링 참여하기
            </Button>
          ) : (
            <Button
              href={meetingUrl}
              target='_blank'
              style={{ width: '100%', marginTop: '5px' }}
              className='btn-join'
            >
              멘토링 참여하기
            </Button>
          )}
        </>
      )}
      {useResume === true && (
        <>
          {get(mentee, 'resume_file.absolute_url') && (
            <Button
              href={`${Configs.API_HOST}${get(mentee, 'resume_file.absolute_url')}`}
              className='resume-btn'
            >
              이력서 보기
            </Button>
          )}
        </>
      )}
      {useClassCount === true && (
        <Text style={{ fontSize: 'calc(0.2vw + 10px)', color: '#aeaeae' }}>
          {get(mentee, 'class_count', 0)}개의 지난 수업이 있습니다
        </Text>
      )}
    </CardWrapper>
  );
};

export default MenteeCard;
